import type { AxiosInstance } from "axios";
import {
    hasAnalyticsConsent,
    trackAnalytics,
    analyticsErrorCategory
} from "./analytics";

let successes = 0;

export function observeAnalyticsRequests(client: AxiosInstance): AxiosInstance {
    const starts = new WeakMap<object, number>();
    client.interceptors.request.use((config) => {
        if (typeof window !== "undefined" && hasAnalyticsConsent())
            starts.set(config, Date.now());
        return config;
    });
    const report = (
        config: { url?: string } | undefined,
        status: number | undefined,
        error?: unknown
    ) => {
        if (!config || !starts.has(config)) return;
        const started = starts.get(config)!;
        starts.delete(config);
        if (!error && successes++ % 5 !== 0) return;
        const url =
            typeof config.url === "string" ? config.url.split(/[?#]/)[0] : "";
        const operation = /\/checkout(?:\/|$)/.test(url)
            ? "checkout"
            : /\/reservations(?:\/|$)/.test(url)
            ? "reservations"
            : /\/settings(?:\/|$)/.test(url)
            ? "settings"
            : /\/vouchers?(?:\/|$)/.test(url)
            ? "vouchers"
            : /\/guests?(?:\/|$)/.test(url)
            ? "guests"
            : /\/tickets?(?:\/|$)/.test(url)
            ? "tickets"
            : "other";
        trackAnalytics("api_request_completed", {
            operation,
            sample_rate: error ? 1 : 0.2,
            duration_ms: Date.now() - started,
            status_code: status || 0,
            outcome: error ? "failed" : "success",
            ...(error ? { error_category: analyticsErrorCategory(error) } : {})
        });
    };
    client.interceptors.response.use(
        (response) => {
            report(response.config, response.status);
            return response;
        },
        (error) => {
            report(error?.config, error?.response?.status, error);
            return Promise.reject(error);
        }
    );
    return client;
}
